export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-microphone-cf826f31b889fb1688316b81f497ee1e.svg";